import React, { useEffect } from 'react'
import classNames from 'classnames'
import styles from './Marketplace.module.scss'

const LoadingText = props => (
  <div className={styles.loading_text}>&nbsp;</div>
)

const LoadingTextWhite = props => (
  <div className={styles.loading_text_white}>&nbsp;</div>
)

const LoadingDescription = props => (
  <div className={styles.description}>
    <div className={styles.tag_line}><LoadingText /></div>
    <div className={styles.product_text}>
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
    </div>
  </div>
)

const LoadingBlock = props => (
  <div>
    <h2 className={styles.product_header}><LoadingText /></h2>
    <div className={styles.product_text}>
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
      <LoadingText />
    </div>
  </div>
)

const ProductDetailsLoading = props => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0)
    }
  })
  return (
    <div className={styles.product}>
      <div className={styles.product_block_blue}>
        <div className={styles.product_container}>
          <div className={styles.title}>
            <h1 className={styles.title}><LoadingTextWhite /></h1>
            <div className={styles.title_partner_name}><LoadingTextWhite /></div>
            <div className={classNames(styles.stats_mini, "hidden-lg")}>
              <div className={styles.stat_container}>
                <div className={styles.stat_blocks}>
                  <div className={styles.stat_text}><LoadingTextWhite /></div>
                </div>
              </div>
              <div className={styles.stat_container}>
                <div className={styles.stat_blocks}>
                  <div className={styles.stat_text}><LoadingTextWhite /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.product_nav}>
        <div className={classNames('container-fluid', styles['pt-md'], styles['pb-md'], styles['pl-none'], styles['pr-none'])}>
          <ul>
            <li key="description"><div>Description</div></li>
            <li key="advantage"><div>Advantage</div></li>
            <li key="benefits"><div>Benefits</div></li>
          </ul>
        </div>
      </div>
      <div className={styles.product_container}>
        <div className={styles.product_text_container}>
          <LoadingDescription />
          <LoadingBlock />
          <LoadingBlock />
          <LoadingBlock />
        </div>
      </div>
      <div className={styles.product_container}> </div>
      <div className={classNames(styles.product_container, styles.related)}></div>
    </div>
  )
}

export default ProductDetailsLoading
